import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CognitoService } from '@dash/randy/security/service/cognito.service';

@Component({
    template: '',
    standalone: false
})
export class LogoutComponent implements OnInit {
  constructor(private cognitoService: CognitoService, private router: Router) {}

  async ngOnInit(): Promise<void> {
    console.log('Signing out of cognito via component');
    await this.cognitoService.signOut();
    console.log('Signed out of cognito via component');
    // this.redirectTo('login');
  }

  redirectTo(uri: string): void {
    // this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    //   this.router.navigate([uri]));

    this.router.navigate([uri]).then(() => {
      window.location.reload();
    });
  }
}
